document.addEventListener("DOMContentLoaded", function () {
  var debounce = require('debounce');

  var header = document.getElementsByTagName('header')[0];

  function setHeaderHeightVar() {
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
  }

  setHeaderHeightVar();
  window.addEventListener('resize', debounce(setHeaderHeightVar, 100));
  document.documentElement.style.setProperty('--jump-links-height', '0px');

  function initStickyNav(sticky_target) {
    if (!sticky_target) {
      return;
    }

    var is_jump_links = sticky_target.classList.contains('jump-links-block-block');
    var sticky_distance = window.innerHeight;
    var sticky_lock = false;
    var scroll_pos_prev;
    window.addEventListener('scroll', debounce(function () {
      var scroll_pos = window.pageYOffset;
      var scroll_up = sticky_target.classList.contains('sticky-nav-scrollup');
      var scroll_direction = scroll_pos > scroll_pos_prev ? 'down' : 'up';
      var scroll_threshold = scroll_direction == 'up' ? scroll_pos_prev - scroll_pos > 10 : scroll_pos - scroll_pos_prev > 10;

      if (!sticky_lock && scroll_pos >= sticky_distance) {
        if (!scroll_up || scroll_up && scroll_direction == 'up' && scroll_threshold) {
          var sticky_styles = window.getComputedStyle(sticky_target); //if the element is relative, we need to add an offset

          if (sticky_styles.getPropertyValue('position') == 'static' || sticky_styles.getPropertyValue('position') == 'relative') {
            var sticky_height = sticky_target.offsetHeight;
            this.document.body.style.paddingTop = sticky_height + 'px';
          }

          if (is_jump_links) {
            this.document.documentElement.style.setProperty('--jump-links-height', sticky_target.offsetHeight + 'px');
          }

          sticky_target.classList.add('sticky-nav-active');
          sticky_target.classList.add('sticky-nav-transition-enter');
          sticky_lock = true;
          this.setTimeout(function () {
            sticky_target.classList.remove('sticky-nav-transition-enter');
          }, 300);
        }
      } else if (sticky_lock && (scroll_pos < sticky_distance || scroll_up && scroll_direction == 'down' && scroll_threshold)) {
        sticky_target.classList.add('sticky-nav-transition-exit');
        this.setTimeout(function () {
          this.document.body.style.paddingTop = '';

          if (is_jump_links) {
            this.document.documentElement.style.setProperty('--jump-links-height', '0px');
          }

          sticky_target.classList.remove('sticky-nav-transition-exit');
          sticky_target.classList.remove('sticky-nav-active');
          sticky_lock = false;
        }, 100);
      }

      scroll_pos_prev = scroll_pos;
    }, 10));
  }

  initStickyNav(header);
  document.querySelectorAll('.jump-links-block-block').forEach(initStickyNav);
});